import reducerRegistry from '../../reduxUtils/reducerRegistry';

const initialUserState = {
  showAdCube: false,
};
const reducerName = 'WithCube';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const SHOW_CUBE_AD = createActionName('SHOW_CUBE_AD');
export const HIDE_CUBE_AD = createActionName('HIDE_CUBE_AD');
function setShowAdCube() {
  return {
    type: SHOW_CUBE_AD,
    payload: true,
  };
}
function setHideAdCube() {
  return {
    type: HIDE_CUBE_AD,
    payload: false,
  };
}
export function showAdCubeFunction() {
  return dispatch => {
    dispatch(setShowAdCube());
  };
}
export function hideCubeAdFunction() {
  return dispatch => {
    dispatch(setHideAdCube());
  };
}
export default function reducer(state = initialUserState, action) {
  switch (action.type) {
    case SHOW_CUBE_AD:
      return {
        ...state,
        showAdCube: action.payload,
      };
    case HIDE_CUBE_AD:
      return {
        ...state,
        showAdCube: action.payload,
      };
    default:
      return state;
  }
}
reducerRegistry.register(reducerName, reducer);
